import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";
import classnames from "classnames";

import type { DirectionalIconComponent } from "@jti/brand-icons";

import styles from "./Icon.module.scss";

export type IconProps = {
  icon: DirectionalIconComponent;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  className?: string;
} & SafeHtmlAttributes<HTMLSpanElement>;

const sizeClassMap: Record<NonNullable<IconProps["size"]>, string> = {
  xs: styles["size-xs"],
  sm: styles["size-sm"],
  md: styles["size-md"],
  lg: styles["size-lg"],
  xl: styles["size-xl"],
  "2xl": styles["size-2xl"],
};

export const Icon = ({ icon: IconComponent, size = "md", className, "aria-label": ariaLabel, ...rest }: IconProps) => {
  const isDecorative = !ariaLabel;

  return (
    <span
      className={classnames(styles.icon, sizeClassMap[size], className)}
      role={isDecorative ? undefined : "img"}
      aria-label={ariaLabel}
      aria-hidden={isDecorative ? true : undefined}
      {...rest}
    >
      <IconComponent aria-hidden="true" focusable="false" />
    </span>
  );
};
